import {Box} from '@chakra-ui/react';
import {ScrollingMenu, ScrollingMenuCard} from 'components/shared';
import {FC} from 'react';
import {IProviderItem} from 'types';

import {ProviderLogo} from '../provider-logo';

interface Props {
  items?: IProviderItem[];
}

export const ProviderLogoList: FC<Props> = ({items}) => {
  if (!items?.length) return null;

  return (
    <ScrollingMenu>
      {items.map((item, index) => (
        <ScrollingMenuCard itemId={`element-${index}`} key={item.id}>
          <Box px={['0px', '15px']} _first={{pl: ['30px', '30px']}}>
            <ProviderLogo {...item} size="100px" img={item.logo_thumbnail} />
          </Box>
        </ScrollingMenuCard>
      ))}
    </ScrollingMenu>
  );
};
